import React, { useCallback, useMemo, useContext } from 'react'
import styled from 'styled-components'
import config from 'constants/config'
import BodyText from 'components/Luxkit/Typography/BodyText'
import HelpPane from 'components/Common/HelpPane'
import Modal from 'components/Luxkit/Modal/Modal'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import Clickable from 'components/Common/Clickable'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import ModalContext from 'contexts/ModalContext'

const USPItem = styled(Clickable)`
  display: block;

  & >:last-child {
    display: inline;
    vertical-align: middle;
  }
`
interface Props {
  offer: App.BundleOffer;
  className?: string;
}

type ModalTypes = 'bestPrice'

const ModalTitles = {
  bestPrice: 'Our best price guarantee',
}

function BundleAndSaveUSPs(props: Props) {
  const { offer, className } = props

  const showModal = useContext(ModalContext)
  const onItemClick = useCallback((e: React.MouseEvent<HTMLElement>) => {
    const modalType = e.currentTarget.dataset.type as ModalTypes
    showModal(<Modal
      title={ModalTitles[modalType]}
    >
      {modalType === 'bestPrice' && <VerticalSpacer gap={16}>
        <BodyText variant="large">
          We negotiate the best prices so you don’t have to. In the unlikely event{' '}
          that you find a better price for the same offer, we promise to match it.
        </BodyText>
        <BodyText variant="large">
          <Heading variant="heading5">1. Compare the same offer</Heading>
          Make sure the offer you’ve found is for the same hotel with the same VIP inclusions as our package.
        </BodyText>
        <BodyText variant="large">
          <Heading variant="heading5">2. Record the better price</Heading>
          Take a website screenshot or a photo of a catalogue so you can send it to us.
        </BodyText>
        <BodyText variant="large">
          <Heading variant="heading5">3. We’ll match the price</Heading>
          Once verified we'll match the price.
        </BodyText>
      </VerticalSpacer>}
      <HelpPane />
    </Modal>)
  }, [showModal])

  const disableBestPriceGuarantee = useMemo(() => !Object.values(offer.bundledOffers).some((o) => o.type === 'hotel' && !o.disableBestPriceGuarantee), [offer.bundledOffers])

  return (<VerticalSpacer gap={8} className={className}>
    {config.bestPriceGuarantee && !disableBestPriceGuarantee && <USPItem
      data-type="bestPrice"
      onClick={onItemClick}
    >
      <BodyText
        variant="medium"
        colour="highlight-secondary"
        weight="bold"
        as="span"
      >
        Best price guarantee
      </BodyText>{' '}
      <LineInfoCircleIcon colour="neutral-one" size="XS" />
    </USPItem>}
  </VerticalSpacer>)
}

export default React.memo(BundleAndSaveUSPs)
